import React, { Component } from "react";
import { connect } from "react-redux";
import { changeEditerModeAction, changeLocInfoAction } from "../../redux/app/actions";
import { changeNameAction, addDsAction, changeDsAction } from "../../redux/csLine/actions";
import { regEditerAction } from "../../redux/editer/actions";
import { openSwAction } from "../../redux/ui/actions";
import Sw from "../common/Sw";

const mapStateToProps = (state) => {
    return {
        regMode: state.appReducer.regMode,
        ds: state.csLineReducer.dataset,
        selRow: state.csLineReducer.selRow,
        name: state.csLineReducer.name,
    };
};

class Main extends Component {
    constructor(props) {
        super(props);
        this.ds = null;
        this.dsID = Object.keys(this.props.ds).length + 1;
        this.orgCoord = null;
        this.changeName = this.changeName.bind(this);
        this.doOK = this.doOK.bind(this);
        this.doCancel = this.doCancel.bind(this);
        this.closeSw = this.closeSw.bind(this);
        this.props.dispatch(changeEditerModeAction(1));

        //ボーリングエディタを閉じる
        if (window.getBoringID() !== null) {
            let answer = window.confirm("ボーリングエディタを登録しますか。");
            this.props.dispatch(regEditerAction(answer));
        }

        let isEditMode = false;
        if (this.props.regMode === 1) {
            //編集モードの場合
            isEditMode = true;
            this.ds = this.props.ds[this.props.selRow];
            this.dsID = this.ds.ID;
            this.orgCoord = this.ds.coords;

            this.props.dispatch(changeNameAction(this.ds.name));
            window.setDsCoord(this.orgCoord);
        }

        //window.setDrawView();
        window.startCsLine(this.dsID, isEditMode);
        window.setDrawingFlag(true);
    }

    componentDidUpdate(prevProps) {
        /*
         * 登録OK
         * @since hara 2020-10-12
         */
        if (prevProps.ds !== this.props.ds) this.closeSw();
    }

    /*
     * 名称変更
     * @param {Event} e イベント情報
     * @since hara 2020-09-09
     */
    changeName(e) {
        this.props.dispatch(changeNameAction(e.target.value));
    }

    /*
     * 登録OK
     * @since hara 2020-10-05
     */
    doOK() {
        if (window.existCsLineName(this.dsID)) {
            let divNum = 3;
            let estFlg = 0;
            let action = addDsAction;
            const newCoord = window.getCsLineCoord();

            if (this.props.regMode === 1) {
                //編集モードの場合
                divNum = this.ds.divNum;
                action = changeDsAction;
                if (JSON.stringify(this.orgCoord) === JSON.stringify(newCoord))
                    //編集前の座標と編集後の座標が同じ場合
                    estFlg = this.ds.estFlg;
            }

            this.props.dispatch(
                action({
                    ID: this.dsID,
                    name: this.props.name,
                    coords: newCoord,
                    divNum: divNum,
                    estFlg: estFlg,
                }),
            );

            window.setCsLinePopup(this.dsID, this.props.name);
            window.setDrawingFlag(false);
        } else {
            alert("断面ラインを作成してください。");
        }
    }

    /*
     * 登録キャンセル
     * @since hara 2020-10-13
     */
    doCancel() {
        window.delCsLine(this.dsID);
        if (this.props.regMode === 1) {
            //修正モードの場合
            const coords = [];
            this.props.ds[this.props.selRow].coords.forEach((el) => {
                coords.push([el[1], el[2]]);
            });
            window.createCsLine(coords, this.dsID);
        }

        window.setCsLinePopup(this.dsID, this.props.name);
        window.setDrawingFlag(false);
        this.closeSw();
    }

    /*
     * サブウィンドウを閉じる
     * @since hara 2020-10-05
     */
    closeSw() {
        //プロパティー初期化
        this.props.dispatch(changeNameAction(""));
        this.props.dispatch(openSwAction("pos"));
        this.props.dispatch(changeEditerModeAction(0));

        window.endCsLine();
        window.setBoringID();
        //window.setNormalView();
    }

    render() {
        return (
            <Sw title="予測位置（断面）">
                <div className="Unit l-row">
                    <label>ID：</label>
                    <p>{this.dsID}</p>
                    <label className="l-blank">名称：</label>
                    <input className="textM" type="text" value={this.props.name} onChange={this.changeName} />
                </div>

                <fieldset className="Unit l-mtS">
                    <legend>説明</legend>
                    <p>
                        クリック：ポイント追加
                        <br />
                        ダブルクリック：ポイント追加 ＆ 入力終了
                        <br />
                        Enter&thinsp;キー：入力終了
                        <br />
                        Esc&thinsp;キー：1点戻る
                    </p>
                </fieldset>

                <div className="l-right l-mtM">
                    <button className="cBtn" onClick={this.doOK}>
                        OK
                    </button>
                    <button className="cBtn l-mlS" onClick={this.doCancel}>
                        キャンセル
                    </button>
                </div>
            </Sw>
        );
    }
}

export default connect(mapStateToProps)(Main);
